export const Notification = {
	type: {
		success: 'success',
		error: 'error',
	},
	message: {
		success: '¡Bien!',
		error: '¡Ups!',
	},
};
